export const BREADCRUMB_CUSTOM_TITLES: Record<string, string> = {};
